import React, { useState } from "react";
import { TextField, IconButton, Box } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import Label from "../Label";
const input = (props) => {
    const [patternFormat] = useState(props.pattern ? props.pattern : '.*');
    const required = props.required;
    const value = props.value;
    // const isValidLength = value?.length === 5 && props.label === "Panel Code";
    let defaultClassName = props.defaultClassName ? props.defaultClassName : '';
    const shouldShowError = defaultClassName ? true : required ? (value ? false : true) : false



    return (
        <Box>
            {props.label && <Label isEditIcon={props.isEditIcon} module={props.module} label={props.label} labelClassName={props.labelClassName ? props.labelClassName : ""} />}
            <TextField
                id={props.id ? props.id : "standard-basic"} variant="outlined"
                required={shouldShowError ? shouldShowError : false}
                InputLabelProps={props.value ? { shrink: props.value ? true : false } : {}}
                type={props.type}
                fullWidth
                name={props.name} placeholder={props.placeholder} value={props.value}
                onChange={props.onValueChange}
                onBlur={props.onValueBlur && props.onValueBlur}
                autoComplete="off"
                inputProps={{ pattern: patternFormat, maxLength: props.maxLength }
                }
                role="textbox"
                data-testid={props['data-testid'] ?? props.id}
                aria-label={props['aria-label']}
                pattern={patternFormat}
                disabled={props.disabled ? props.disabled : false}
                tabIndex={props.tabIndex ? props.tabIndex : ''}
                onKeyDown={props.onKeyDown && props.onKeyDown}
                helperText={props.helperText}
                error={props.error ?? false}
                onPaste={props.onPaste}
                InputProps={{
                    // clearButton within the MUI TexField to clear the value
                    endAdornment: (
                        props.clearButton && props.value?.length >= 1 ?
                            (<IconButton onClick={props.clearInput} data-testid="clear-button" id={props.id ? props.id + "-clear-button" : 'clear-button'}>
                                <ClearIcon fontSize="small"/>
                            </IconButton>) :
                            ''
                    ),
                    autoComplete: props?.newPassword ? 'new-password' : '',
                    'aria-label': props['aria-label'],
                    'data-testid': props['data-testid']
                }}
            />
        </Box>
    )

}

export default input;